import { Accordion } from '../../../../../components/general/accordion';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Table } from '../../../../../components/general/table';

export const AccountClientHistory = () => {
    return (
        <Accordion
            title="HISTÓRICO DE CLIENTE"
            icon={<AssignmentIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Table
                columns={[
                    {
                        field: 'date',
                        headerName: 'Fecha de creación',
                        flex: 1,
                    },
                    {
                        field: 'isClient',
                        headerName: '¿Es cliente?',
                        flex: 1,
                    },
                    {
                        field: 'callId',
                        headerName: 'CALL ID',
                        flex: 1,
                    },
                ]}
                rows={[]}
            />
        </Accordion>
    );
};
